import BASEURLGESTTOR from '../api/gesttor'
import { contaCadastrar, extratosParamsPayload, paramsListaContas, transferenciaPayload, atualizarContaPayload } from "../../interfaces/contas"

export function cadsatrarConta (payload: contaCadastrar) {
    return BASEURLGESTTOR.post('/contas', payload)
}

export function atualizarConta (id: string, payload: atualizarContaPayload) {
    return BASEURLGESTTOR.patch(`/contas/${id}`, payload)
}

export function listarContas (params: paramsListaContas) {

    if(params.dataFinal) {

        return BASEURLGESTTOR.get(`/contas?descricao=${params.descricao}&situacao=${params.situacao}&dataFinal=${params.dataFinal}`)
    }

    return BASEURLGESTTOR.get(`/contas?descricao=${params.descricao}&situacao=${params.situacao}`)
}

export function transferenciaBancaria (payload: transferenciaPayload) {
    return BASEURLGESTTOR.post('/contas/transferencia', payload)
}

export function extratosBancarios (params: extratosParamsPayload) {
    return BASEURLGESTTOR.get(`/contas/extrato?idConta=${params.idConta}&pagina=${params.pagina}&dataInicial=${params.dataInicial}&dataFinal=${params.dataFinal}`)
}